import React, { useState, useEffect } from 'react';
import '../style/scroll.css';
import { FaArrowUp, FaEllipsisH, FaWhatsapp, FaInstagram, FaLinkedin } from 'react-icons/fa';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isSocialOpen, setIsSocialOpen] = useState(false);

  // Show arrow when scrolling down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
        setIsSocialOpen(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setIsSocialOpen(false);
  };

  // Toggle social media icons
  const toggleSocial = () => {
    setIsSocialOpen(!isSocialOpen);
  };

  // Social media links
  const socialLinks = {
    whatsapp: 'https://wa.me/+923215416819',
    instagram: 'https://www.instagram.com/404fxvisuals?igsh=OG9reDNldTU0cDlh',
    linkedin: 'https://www.linkedin.com/company/404fxvisuals/about/?viewAsMember=true'
  };

  const handleSocialClick = (platform) => {
    window.open(socialLinks[platform], '_blank');
    setIsSocialOpen(false);
  };

  return (
    <div className={`scroll-to-top ${isVisible ? 'visible' : ''}`}>
      {/* Social Media Popup in Arc Shape */}
      <div className={`social-arc ${isSocialOpen ? 'open' : ''}`}>
        <button 
          className="social-btn whatsapp"
          onClick={() => handleSocialClick('whatsapp')}
          title="WhatsApp"
        >
          <FaWhatsapp />
        </button>
        <button 
          className="social-btn instagram"
          onClick={() => handleSocialClick('instagram')}
          title="Instagram"
        >
          <FaInstagram />
        </button>
        <button 
          className="social-btn linkedin"
          onClick={() => handleSocialClick('linkedin')}
          title="LinkedIn"
        >
          <FaLinkedin />
        </button>
      </div>

      {/* Three Dots Button */}
      <button 
        className="dots-btn"
        onClick={toggleSocial}
        title="Quick Links"
      >
        <FaEllipsisH />
      </button>

      {/* Arrow Button */}
      <button 
        className="arrow-btn"
        onClick={scrollToTop}
        title="Scroll to Top"
      >
        <FaArrowUp />
      </button>
    </div>
  );
};

export default ScrollToTop;